import { XerxesJwtToken } from "@sky/xerxes-client-react";
import { COGNITO } from "../config";

export const hasAdminGroupMembership = (token: XerxesJwtToken | null) => {
  if (token) {
    const roles: string[] | undefined = token.getClaims()['cognito:roles'];
    if (roles && Array.isArray(roles)) {
      return roles.filter(role => role.includes(COGNITO.roleName)).length === 1 || false;
    }
  }

  return false;
}